import DetailSubscription from "@dropDesk/presentation/components/detail_subscription";
import React from "react";
import {
    ContentDetail,
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/styled";
import {CompanyPaymentInfo} from "@dropDesk/domain/entities/company/company.entity";
import {
    ContentButton,
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/payment_info/styled";
import PaymentInfos from "@dropDesk/presentation/pages/subscription/ui/checkout/payment_type/payment_info_detail/infos";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {observer} from "mobx-react";
import {
    ContentInfos,
    DescriptionWrapper,
    IconBadge,
    IconWrapper
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/payment_method/styled";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {HighLightHashTag} from "@dropDesk/presentation/components/high_light_hashtag";

const PaymentInfo = observer((
    {
        paymentInfo,
        loading,
        disabled,
        handleEditPaymentInfo,
    }: {
        paymentInfo?: CompanyPaymentInfo
        loading: boolean
        disabled: boolean
        handleEditPaymentInfo: () => void
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <DetailSubscription
            title={'Dados de cobrança'}
            description={'Dados responsáveis pelo faturamento da sua conta.'}
            content={
                <ContentDetail background={'transparent'}>
                    {paymentInfo &&
                        <ContentInfos>
                            <IconWrapper>
                                <IconBadge background={`${colors.accent}12`}>
                                    <DropDeskIcon icon={ICONS_DROPDESK.form} size={20} color={colors.accent}/>
                                </IconBadge>
                            </IconWrapper>
                            <DescriptionWrapper>
                                <PaymentInfos paymentInfo={paymentInfo}/>
                            </DescriptionWrapper>

                        </ContentInfos>
                    }
                    <ContentButton>
                        <ButtonMain
                            style={{paddingLeft: 10, paddingRight: 5}}
                            widthPercentage={100}
                            letterFontSize={12}
                            disabled={disabled}
                            loading={loading}
                            height={35}
                            color={colors.background}
                            borderColor={colors.accent}
                            letterColor={colors.accent}
                            useSuffixIcon={true}
                            type={"submit"}
                            letter={'Trocar dados'}
                            onClick={() => handleEditPaymentInfo()}
                        />
                    </ContentButton>
                </ContentDetail>
            }
        />
    );
});
export default PaymentInfo;
